export function Trash(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.66662 6.33353C7.66662 5.96534 7.36814 5.66686 6.99995 5.66686C6.63176 5.66686 6.33328 5.96534 6.33328 6.33353V9.66686C6.33328 10.0351 6.63176 10.3335 6.99995 10.3335C7.36814 10.3335 7.66662 10.0351 7.66662 9.66686V6.33353Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4666 2.33353C10.4666 1.15532 9.51149 0.200195 8.33328 0.200195H5.66662C4.48841 0.200195 3.53328 1.15532 3.53328 2.33353V2.53353H0.999951C0.558123 2.53353 0.199951 2.8917 0.199951 3.33353C0.199951 3.77536 0.558123 4.13353 0.999951 4.13353H1.56458L2.11353 11.8189C2.19327 12.9352 3.12221 13.8002 4.24144 13.8002H9.75846C10.8777 13.8002 11.8066 12.9352 11.8864 11.8189L12.4353 4.13353H13C13.4418 4.13353 13.7999 3.77536 13.7999 3.33353C13.7999 2.8917 13.4418 2.53353 13 2.53353H10.4666V2.33353ZM8.86662 2.53353H5.13328V2.33353C5.13328 2.03898 5.37207 1.8002 5.66662 1.8002H8.33328C8.62784 1.8002 8.86662 2.03898 8.86662 2.33353V2.53353ZM3.70947 11.7049L3.16866 4.13353H10.8312L10.2904 11.7049C10.2705 11.984 10.0383 12.2002 9.75846 12.2002H4.24144C3.96164 12.2002 3.7294 11.984 3.70947 11.7049Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
